import Action from 'redux/helpers/createAction'
const name = 'addons'

export const getAddons = Action(name + '/GET')
export const getAddonsSuccess = Action(name + '/GET_SUCCESS', data => ({
  data
}))
export const getAddonsFailure = Action(name + '/GET_FAILURE', error => ({
  error
}))

export const getOwnedAddons = Action(name + '/GET_OWNED')
export const getOwnedAddonsSuccess = Action(name + '/GET_OWNED_SUCCESS', data => ({
  data
}))
export const getOwnedAddonsFailure = Action(name + '/GET_FAILURE', error => ({
  error
}))

export const removeAddon = Action(name + '/REMOVE', id => ({
  id
})) 
